export const SET_LOADER     = "SET_LOADER";
export const CLEAR_STORAGE  = "CLEAR_STORAGE"

export const setLoader = ({ state }) => ({

  type: SET_LOADER,

  payload: state

});

export const clearStorage = ({ state }) => ({
  type: CLEAR_STORAGE,

  payload: state
});
